import { useRole } from '@/hooks/useRole'
import { SharedProps } from '@/types'
import { Head, useForm, usePage } from '@inertiajs/react'
import { Button, Card, Select, Stack, TextInput, Title } from '@mantine/core'
import React from 'react'

export default function NewAuthorizationPage() {
  const { current_organization } = usePage<SharedProps>().props
  const { data, setData, post, processing, errors } = useForm({
    name: '',
    email: '',
    role: 'accueil',
  })
  const { isBoutique } = useRole()

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/organizations/${current_organization?.slug}/authorizations`)
  }

  return (
    <>
      <Head title="Nouvelle autorisation" />

      <Stack maw={600} mx="auto" w="100%">
        <Title>Nouvelle autorisation</Title>

        <Card withBorder radius="md" p="xl" shadow="sm">
          <form onSubmit={handleSubmit}>
            <Stack gap="md">
              <TextInput
                label="Nom"
                placeholder="Jean Dupont"
                value={data.name}
                required
                onChange={(e) => setData('name', e.target.value)}
                error={errors.name}
              />

              <TextInput
                label="Email de l'utilisateur"
                placeholder="exemple@email.com"
                required
                value={data.email}
                onChange={(e) => setData('email', e.target.value)}
                error={errors.email}
              />

              <Select
                label="Rôle"
                required
                data={[
                  { value: 'admin', label: 'Administrateur' },
                  { value: 'atelier', label: 'Atelier' },
                  { value: 'accueil', label: 'Accueil' },
                  { value: 'courier', label: 'Coursier' },
                ]}
                disabled={isBoutique}
                value={data.role}
                onChange={(value) => setData('role', value || 'atelier')}
                error={errors.role}
              />

              <Button type="submit" loading={processing} mt="md" fullWidth>
                Créer l'autorisation
              </Button>
            </Stack>
          </form>
        </Card>
      </Stack>
    </>
  )
}
